import { setProp } from '@/store/helper';
import * as types from '@/store/mutation-types';

export default {
  [types.SET_PASSWORD_RESET_EMAIL]: setProp('email'),
  [types.SET_PASSWORD_RESET_TOKEN]: setProp('token'),
  [types.SET_STATUS_PENDING]: setProp('status.pending'),
};
